import { Link } from "react-router-dom";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import Gallery from "@/components/Gallery";
import { CE_OFERIM } from "@/data/content";

export default function CeOferim() {
  const c = CE_OFERIM;
  return (
    <div data-testid="ce-oferim-page">
      <PageHero kicker={c.kicker} title={c.title} intro={c.intro} variant="default" />

      {/* DIGITAL */}
      <section className="py-14 md:py-20">
        <div className="container-x">
          <Reveal>
            <span className="overline">Online</span>
            <h2 className="mt-5 text-3xl md:text-5xl font-bold tracking-tight">{c.digital.title}</h2>
            <p className="mt-5 max-w-3xl lead">{c.digital.lead}</p>
          </Reveal>
          <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {c.digital.channels.map((ch, i) => (
              <Reveal key={ch.title} delay={(i % 3) * 0.08}>
                <div className="card h-full p-7 md:p-8">
                  <div className="mb-3 h-1.5 w-10 rounded-full bg-brand" />
                  <h3 className="text-xl font-bold tracking-tight">{ch.title}</h3>
                  <p className="mt-3 text-slate-600 leading-relaxed text-[16px]">{ch.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* OFFLINE LEAD */}
      <section className="bg-white py-12 md:py-16 border-y border-slate-100">
        <div className="container-x max-w-3xl">
          <Reveal>
            <span className="overline">Offline</span>
            <h2 className="mt-4 text-3xl md:text-5xl font-bold tracking-tight">{c.offline.title}</h2>
            <p className="mt-5 lead">{c.offline.lead}</p>
          </Reveal>
        </div>
      </section>

      {/* CARAVANA */}
      <section className="py-14 md:py-20">
        <div className="container-x">
          <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:items-start">
            <Reveal>
              <h3 className="text-2xl md:text-3xl font-bold tracking-tight">{c.caravana.title}</h3>
              <div className="mt-4 space-y-4">
                {c.caravana.text.map((t, i) => (
                  <p key={i} className="text-slate-600 leading-relaxed text-[17px]">{t}</p>
                ))}
              </div>
              <div className="mt-8 grid grid-cols-2 gap-3">
                {c.caravana.stats.map((s, i) => (
                  <div key={i} className="rounded-2xl bg-slate-50 p-4 text-center">
                    <div className="text-2xl md:text-3xl font-extrabold text-brand">{s.value}</div>
                    <div className="mt-1 text-xs text-slate-500 font-medium">{s.label}</div>
                  </div>
                ))}
              </div>
            </Reveal>
            <Reveal delay={0.12}>
              <Gallery images={c.caravana.gallery} testid="caravana-gallery" />
            </Reveal>
          </div>
          <Reveal delay={0.05}>
            <p className="mt-10 rounded-3xl border border-slate-100 bg-white p-6 md:p-8 text-slate-700 leading-relaxed text-[17px]">
              {c.caravana.extra}
            </p>
          </Reveal>
        </div>
      </section>

      {/* OFFLINE BLOCKS */}
      <section className="bg-white py-14 md:py-20 border-t border-slate-100">
        <div className="container-x grid gap-6 md:gap-8 md:grid-cols-2">
          {c.offlineBlocks.map((b, i) => (
            <Reveal key={b.title} delay={(i % 2) * 0.1}>
              <div className="card h-full p-8 md:p-10">
                <h3 className="text-2xl md:text-3xl font-bold tracking-tight">{b.title}</h3>
                <div className="mt-4 space-y-3">
                  {b.body.map((p, j) => (
                    <p key={j} className="text-slate-600 leading-relaxed text-[16px]">{p}</p>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <div className="container-x mt-12">
          <Reveal>
            <Link to="/contact" data-testid="ce-oferim-cta" className="btn-primary">
              {c.cta}
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
